<template>
  <div>
    <SkuMaterials
      :disabled="disabled"
      :isFormal="isFormal"
      :amzSkuCode="amzSkuCode"
      :amzSkuMaterialGroup="'packaging'"
    />
  </div>
</template>
<script>
import SkuMaterials from '../aws-sku-materials'
export default {
  components: { SkuMaterials },
  props: {
    disabled: { type: Boolean, default: true },
    isFormal: { type: Boolean, default: false },
    amzSkuCode: { type: String, default: '' },
  },
}
</script>
